import { render } from "./ViewParent.vue?vue&type=template&id=544c0434&ts=true"
import script from "./ViewParent.vue?vue&type=script&lang=ts"
export * from "./ViewParent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__